import { Assets, Sprite, Texture } from 'pixi.js';
import type { Application } from 'pixi.js';

export default () => {
  const createImageResource = (imageName: string, app: Application) => {
    const texture = Assets.get(imageName);

    if (!texture) {
      throw new Error(`Texture not found for image: ${imageName}`);
    }

    const sprite = new Sprite(texture);
    sprite.width = app.screen.width;
    sprite.height = app.screen.height;

    return { sprite, texture };
  };

  const createImageResourceIos = async (imagePath: string, app: Application) => {
    const imageElement = new Image();
    const imageSrc = imagePath.includes('.') ? imagePath : `/${imagePath}.png`;
    imageElement.src = imageSrc;

    await new Promise<void>((resolve, reject) => {
      if (imageElement.complete) {
        resolve();
      } else {
        imageElement.addEventListener('load', () => resolve(), { once: true });
        imageElement.addEventListener('error', reject, { once: true });
      }
    });

    const texture = Texture.from(imageElement);
    const sprite = new Sprite(texture);

    sprite.width = app.screen.width;
    sprite.height = app.screen.height;

    return { sprite, texture };
  };

  return { createImageResource, createImageResourceIos };
};
